// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as AuthContext$PorterinFeature from "../../../../contexts/auth-context/AuthContext.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as DownloadAppCardModuleScss from "../styles/DownloadAppCard.module.scss";
import * as DownloadAnalyticsHelper$PorterinFeature from "../../helpers/DownloadAnalyticsHelper.mjs";

var styles = DownloadAppCardModuleScss;

function DownloadAppCardCmp(Props) {
  var data = Props.data;
  var image = Props.image;
  var router = Router.useRouter();
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match = AuthContext$PorterinFeature.useAuthContext(undefined);
  var user = match.user;
  var match$1 = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match$1.category;
  var download_link = React.useMemo((function () {
          return DownloadAnalyticsHelper$PorterinFeature.getAppDownloadLinkSection(UrlUtils$Catalyst.getURLParams(router.asPath), citySelectedContext.city_selected, false, router.pathname);
        }), [
        router,
        citySelectedContext
      ]);
  var handleDownloadClick = React.useCallback((function (_event) {
          DownloadAnalyticsHelper$PorterinFeature.publishDownloadAppCardEvent(category, user);
          JsBindings$PorterinUtils.redirect(download_link);
        }), [
        citySelectedContext.category,
        download_link
      ]);
  return React.createElement("div", {
              className: styles.card
            }, React.createElement("div", {
                  className: styles.text
                }, data.text), React.createElement("div", {
                  className: styles["download-btn"],
                  onClick: handleDownloadClick
                }, data.cta_text), React.createElement("div", {
                  className: styles.image
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: image.src,
                      height: image.height,
                      width: image.width,
                      alt: image.alt
                    })));
}

var make = DownloadAppCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
